<template>
    <div class="login-bg">
        <h2 class="project-title">苏州高新区2026年第二次面向社会认定中小学教师资格  现场确认预约</h2>
        <el-card class="card" v-if="isLogin == 0">
            <div slot="header">
                <span style="font-size:18px">登录</span>
                <el-link style="float:right;" type="primary" :underline="false" @click="switchPage(1)">前往注册 <i
                        class="el-icon-d-arrow-right"></i></el-link>
            </div>
            <el-form :model="login" :rules="login_rules" ref="loginForm" label-width="80px">
                <el-form-item label="用户名" prop="uaccount">
                    <el-input v-model="login.uaccount" placeholder="手机号/身份证号"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="upass">
                    <el-input v-model="login.upass" type="password"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="vcode">
                    <div class="auth-container" >
                        <el-input v-model="login.vcode" placeholder="请输入验证码" style="width: 10rem;"></el-input>
                        <img id="auth_img" :src="imageUrl" @click="refreshAuthImage" />
                    </div>

                </el-form-item>
                <div style="text-align:center">
                    <el-button type="primary" style="width:300px" @click="loginClick">登录</el-button>
                    <br><br>
                    <el-link type="default" @click="switchPage(2)">忘记密码?</el-link>
                </div>
            </el-form>
        </el-card>
        <el-card class="card" v-else-if="isLogin == 1">
            <div slot="header">
                <span style="font-size:18px">注册</span>
                <el-link style="float:right;" type="primary" :underline="false" @click="switchPage(0)">前往登录 <i
                        class="el-icon-d-arrow-right"></i></el-link>
            </div>
            <el-form :model="regist" :rules="regist_rules" ref="registForm" label-width="80px">
                <el-form-item label="姓名" prop="realname">
                    <el-input v-model="regist.realname"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="regist.phone"></el-input>
                </el-form-item>
                <el-form-item label="身份证" prop="national_id">
                    <el-input v-model="regist.national_id"></el-input>
                </el-form-item>
                <el-form-item label="网报号" prop="internet_reg_no">
                    <el-input v-model="regist.internet_reg_no" placeholder="网络报名号"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="regist.password"></el-input>
                </el-form-item>
                <div style="text-align:center">
                    <el-button type="primary" style="width:300px" @click="registClick">注册</el-button>
                </div>
            </el-form>
        </el-card>
        <el-card class="card" v-else>
            <div slot="header">
                <span style="font-size:18px">重置密码</span>
                <el-link style="float:right;" type="primary" :underline="false" @click="switchPage(0)">前往登录 <i
                        class="el-icon-d-arrow-right"></i></el-link>
            </div>
            <el-form :model="resetPwd" :rules="resetPwd_rules" ref="resetPwdForm" label-width="94px">
                <el-form-item label="姓名" prop="realname">
                    <el-input v-model="resetPwd.realname"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="resetPwd.phone"></el-input>
                </el-form-item>
                <el-form-item label="身份证" prop="national_id">
                    <el-input v-model="resetPwd.national_id"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input v-model="resetPwd.password"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="confirmPwd">
                    <el-input v-model="resetPwd.confirmPwd"></el-input>
                </el-form-item>
                <div style="text-align:center">
                    <el-button type="primary" style="width:300px" @click="resetPwdClick">重置密码</el-button>
                </div>
            </el-form>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.resetPwd.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            login: {
                uaccount: '',
                upass: '',
                vcode: '',
                vcode_id: ''
            },
            imageUrl: '', // 存储验证码图片的 URL
            login_rules: {
                uaccount: [{ required: true, message: "请输入用户名", trigger: "blur" }],
                upass: [{ required: true, message: "请输入密码", trigger: "blur" },
                { min: 6, message: "密码长度至少6位", trigger: "blur" }],
                vcode:[{ required: true, message: "请输入验证码", trigger: "blur" }]
            },
            regist: {
                realname: '',
                phone: '',
                national_id: '',
                internet_reg_no: '',
                password: ''
            },
            regist_rules: {
                realname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                phone: [{ required: true, message: "请输入手机号", trigger: "blur" },
                {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '请输入正确的手机号',
                    trigger: 'blur'
                }],
                national_id: [{ required: true, message: "请输入身份证", trigger: "blur" },
                {
                    pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                    message: '请输入正确的身份证号',
                    trigger: 'blur'
                }],
                // internet_reg_no:[{ required: true, message: "请输入网络报名号", trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" },
                { min: 6, message: "密码长度至少6位", trigger: "blur" }],
            },
            resetPwd: {
                realname: '',
                phone: '',
                national_id: '',
                password: '',
                confirmPwd: ''
            },
            resetPwd_rules: {
                realname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                phone: [{ required: true, message: "请输入手机号", trigger: "blur" },
                {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '请输入正确的手机号',
                    trigger: 'blur'
                }],
                national_id: [{ required: true, message: "请输入身份证", trigger: "blur" },
                {
                    pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                    message: '请输入正确的身份证号',
                    trigger: 'blur'
                }],
                // internet_reg_no:[{ required: true, message: "请输入网络报名号", trigger: "blur" }],
                password: [{ required: true, message: "请输入新密码", trigger: "blur" },
                { min: 6, message: "密码长度至少6位", trigger: "blur" }],
                confirmPwd: [{ required: true, validator: validatePass2, trigger: "blur" },
                { min: 6, message: "密码长度至少6位", trigger: "blur" }],
            },
            isLogin: 0
        }
    },
    mounted() {
        switch (this.$global.status) {
            case 0:
                this.$router.push('/schoolHome/homepage')
                break;
            case 1:
                this.$router.push('/schoolHome/projectRecord')
                break;
            case 2:
                this.$router.push('/schoolHome/confirmRecord')
                break;
        }
        this.getAuthImg()

    },
    methods: {
        getAuthImg() {
            this.$request.getNDNF(this.$url.type.base, this.$url.school.VerificationCode, success => {
                if (success.code === 'ok') {
                    this.imageUrl = success.img;
                    this.login.vcode_id = success.id;
                }

            })
        },
        refreshAuthImage() {
            // 点击图片时刷新验证码图片
            this.getAuthImg();
        },
        loginClick() {
            this.$refs['loginForm'].validate(valid => {
                if (valid) {
                    this.loginInfo();
                } else {
                    return;
                }
            });
        },
        loginInfo() {
            this.$request.postFormNF(this.$url.type.base, this.$url.school.login, this.login, success => {
                this.$message.success('登录成功')
                this.$router.push('/schoolHome/homepage')
            })
        },
        registClick() {
            this.$refs['registForm'].validate(valid => {
                if (valid) {
                    this.registInfo();
                } else {
                    return;
                }
            });
        },
        registInfo() {
            this.$request.postFormNF(this.$url.type.base, this.$url.school.regist, this.regist, success => {
                this.$message.success('注册成功,请登录')
                this.isLogin = 1
            })
        },
        resetPwdClick() {
            this.$refs['resetPwdForm'].validate(valid => {
                if (valid) {
                    this.resetPwdInfo();
                } else {
                    return;
                }
            });
        },
        resetPwdInfo() {
            this.$request.postFormNF(this.$url.type.base, this.$url.school.resetPwd, this.resetPwd, success => {
                this.$message.success('重置密码成功,请登录')
                this.isLogin = 0
            })
        },
        switchPage(isLogin) {
            let oldLogin = this.isLogin
            if (oldLogin == 1) {
                this.$refs['registForm'].resetFields()
            } else if (oldLogin == 0) {
                this.$refs['loginForm'].resetFields()
            } else {
                this.$refs['resetPwdForm'].resetFields()
            }
            this.isLogin = isLogin
        }
    }
}
</script>
<style scoped>
.login-bg {
    background-image: url('../../assets/img/background.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 70px;
    padding-bottom: 10px;
    overflow-y: auto;
}

.project-title {
    text-align: center;
    padding: 10px;
    color: #454545;
}

.card {
    width: 450px;
    margin: 30px auto;
}

.el-input {
    width: 300px;
}

@media (min-width:320px) and (max-width:500px) {
    .card {
        width: 100%;
        margin: 20px 0;
    }

    .el-input {
        width: 240px;
    }
}

.auth-container {
    display: flex;
    justify-content: space-between;
    width: 91%;
    /* 居中对齐 */
}

#auth_img{
    width: 25%;
}
</style>